<template lang="html">
  <div class="edit-site-shopify tier tier-three">
    <Tooltip
      content="Turn your website into a full E-commerce site by integrating your <strong>Shopify</strong> account"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs :headings="['Your Shopify Details', 'Connect Your Store']">
        <Tab>
          <div>
            <SiteShopifyForm
              @submit="submitSite"
              v-model="site"
              :errors="errors"
            />
          </div>
        </Tab>

        <Tab>
          <div>
            <h2>Connect your store</h2>
            <p>
              Seamless integration with <strong>Shopify Lite</strong> allows you
              to create an ultra-fast, super secure and stylish storefront for
              your business.
            </p>

            <hr />

            <h3>How to connect</h3>

            <div class="helper-text">
              <p>
                Do you already have a
                <a
                  href="https://accounts.shopify.com/store-login"
                  target="_blank"
                  >Shopify store</a
                >
                that you wish to connect to our platform?
              </p>

              <div class="guide-options">
                <btn secondary @click="activateShopifyControls">Yes</btn>

                <router-link
                  class="btn is-secondary"
                  :to="{name: 'create-store'}"
                  >No</router-link
                >
              </div>
            </div>

            <div class="helper-text" v-if="hasShopifyAccount">
              <p>
                Do you have the
                <a
                  href="https://www.shopify.com/admin/settings/channels"
                  target="_blank"
                  >Online Store Sales Channel</a
                >
                activated?
              </p>

              <div class="guide-options">
                <router-link
                  class="btn is-secondary"
                  :to="{name: 'locate-sales-channels'}"
                  >Yes</router-link
                >

                <router-link
                  class="btn is-secondary"
                  :to="{name: 'shopify-create-app'}"
                  >No</router-link
                >
              </div>
            </div>

            <hr />

            <p>Need a hand? Feel free to <a href="/contact">Contact us</a>.</p>
          </div>
        </Tab>
      </Tabs>

      <router-view />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteShopifyForm from '@/components/forms/SiteShopifyForm'
import Tooltip from '@/components/Tooltip'
import Btn from '@/components/Btn'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

export default {
  name: 'EditSiteShopify',

  components: {
    SiteShopifyForm,
    Tooltip,
    Btn,
    Tabs,
    Tab
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {},
      hasShopifyAccount: false
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} Shopify`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Shopify settings updated!`
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'Shopify settings', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    },

    activateShopifyControls() {
      this.hasShopifyAccount = true
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
